<template>
  <div>
    <!--main Start!-->
    <div id="main" class="wp clearfix">
      <el-row>
        <el-col :xs="24" :sm="4" :md="4" :lg="5" :xl="5">
          <div class="leftMenu fl">
            <dl>
              <dt>
                <span>
                  <h4>内容搜索</h4>
                  <h5>Content search</h5>
                </span>
              </dt>
              <dd class="on">
                <a>内容搜索</a>
              </dd>
            </dl>
          </div>
        </el-col>
        <el-col :xs="24" :sm="20" :md="20" :lg="19" :xl="19">
          <div class="rightCon fr">
            <div class="conTop clearfix">
              <div class="crumbs">
                <a href=/sites/jsjgcx/dist/js/"index.html>首页</a>
                <i>-</i>
                 <span v-if="this.searchText==''">内容搜索--默认搜索</span>
                <span v-else>内容搜索--{{searchText}}</span>
               
              </div>
              <div class="conTit clearfix">
                <span>内容搜索</span>
              </div>
            </div>
            <div class="conMain">
              <!-- 数据展示 -->
              <ul class="newsList">
                <li class="clearfix" v-for="item in list" :key="item.id">
                  <a @click="gotodetails(item.id, index.cid)">{{
                    item.title
                  }}</a>
                  <span>{{ item.date }}</span>
                </li>
              </ul>
              <!-- 分页 -->
              <div class="pageNum">
                <div class="page">
                  <el-pagination
                    hide-on-single-page
                    background
                    @size-change="pagesize"
                    @current-change="handleSizeChange"
                    :current-page="pi"
                    :page-size="pagesize"
                    layout="total, prev, pager, next,jumper"
                    :total="total"
                    :pager-count="5"
                  ></el-pagination>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--main End!-->
  </div>
</template>
<script>
import { GET_INDEX_LIST } from "@/api/index";
import { mapMutations, mapGetters, mapState } from "vuex";
export default {
  name: "Student",
  data() {
    return {
      sid: this.$store.state.sid,
      num: 11, //store里id的数据
      name: "资源下载",
      total: null,
      pagesize: 10, //  每页的数据
      loading: true,
      list: [],
      index: {},
    };
  },
  created() {
    this.getLisyIndex();
  },
  computed:{
      ...mapGetters(['searchText'])
  },
  methods: {
    ...mapMutations({
      SET_LISTCID: "SET_LISTCID",
      SET_DETAILSNAME: "SET_DETAILSNAME",
    }),
    getLisyIndex() {
      let data = {
        t:'s',
        sid:"1645607191",
        pi:1,
        ps:10,
        qf:'b',
        qv:this.searchText,
        af:'abcly'
      }
      GET_INDEX_LIST(data).then((res) => {
        this.list = []
        this.loading = false
        res.data.map((item) => {
          if (item.id == 5285) {
            this.zzjgImageAid = item.id;
            this.getZzjgAid();
          } else if (item.id == 5238) {
            this.zzjgImageAid = item.id;
            this.getZzjgAid();
          } else {
            this.list.push(item);
          }
        });
        if (res.request.rc > 10) {
          this.total = res.request.rc;
          this.pageTotalValue = false;
        } else {
          this.total = 0;
          this.pageTotalValue = true;
        }
      });
    },
    gotodetails(index, cid) {
      this.SET_LISTCID({ id: index, cid: this.index.cid });
      this.SET_DETAILSNAME(this.name);
      let routeData = this.$router.resolve({
        path: `/info/1000/${index}.htm`,
      });
      window.open(routeData.href, "_blank");
    },
    handleSizeChange: function (size) {
      let data = {
         t:'s',
        sid:"1645607191",
        pi:size,
        ps:10,
        qf:'b',
        qv:this.searchText,
        af:'abcly'
      };
      GET_INDEX_LIST(data).then((res) => {
        this.list = []
        this.loading = false
        res.data.map((item) => {
          if (item.id == 5285) {
            this.zzjgImageAid = item.id;
            this.getZzjgAid();
          } else if (item.id == 5238) {
            this.zzjgImageAid = item.id;
            this.getZzjgAid();
          } else {
            this.list.push(item);
          }
        });
        if (res.request.rc > 10) {
          this.total = res.request.rc;
          this.pageTotalValue = false;
        } else {
          this.total = 0;
          this.pageTotalValue = true;
        }
      });
    },
  },
  watch:{
      searchText(){
          this.getLisyIndex()
      }
  }
};
</script>
<style scoped>
#main >>> .el-pagination {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  white-space: nowrap;
  padding: 2px 5px;
  color: #303133;
  font-weight: 700;
}
#main >>> .el-pager {
  display: flex;
  flex-wrap: wrap;
}
@import url(../../assets/css/style.css);
@import url(../../assets/css/index.css);
</style>